module.exports = __webpack_public_path__ + "img/deliveree_charge_logo.fc6f5920.png";